import { createFileRoute, useParams } from '@tanstack/react-router';

import {
  AttributeRenderer,
  SectionFormWrapper,
  type RenderContentProps,
  useGetPersonBaseCertificationDetail,
  useUpdatePersonBaseCertificationDetail,
} from '../../../../-shared';

export const Route = createFileRoute(
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/',
)({
  component: PersonBaseCertificationDetail,
});

function PersonBaseCertificationDetail() {
  const { id, personCertificationInformationId } = useParams({
    from: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/',
  });

  return (
    <SectionFormWrapper
      useGetDetailQuery={useGetPersonBaseCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      useSaveMutation={useUpdatePersonBaseCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      renderContent={({ section }: RenderContentProps) => (
        <AttributeRenderer
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
        />
      )}
    />
  );
}
